import YoutubeIcon from '../../public/icon/youtubeIcon';

type UpdatesSectionProps = {
  bgColor?: string;
};

export default function UpdatesSection({ bgColor = 'bg-white' }: UpdatesSectionProps) {
    const updates = [
      {
        date: '26/06/2025',
        title: 'Alphaden Exploration an Production secures $35million facility',
      },
      {
        date: '26/06/2025',
        title: 'The evolution of how we store and distribute energy',
      },
      {
        date: '26/06/2025',
        title: 'Alphaden Energy in the quest to transition out of fossil fuels into renewable energy.',
      },
    ];
  
    return (
      <section className={`${bgColor} py-20 lg:py-32`}>
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          {/* Section Title */}
          <h2 className="text-3xl font-medium  text-[#010305] mb-4">
            Updates, Insights & Milestones
          </h2>
  
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            {/* Left Column - Video/Media */}
            <div className="relative">
              {/* Video Container */}
              <div className="relative max-w-[531px] h-[399px] bg-gray-900 rounded-lg overflow-hidden shadow-xl group cursor-pointer">
                {/* Video thumbnail image */}
                <img 
                  src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763716846/beautiful-alternative-energy-plant-with-solar-panels_1_itgofh.png" 
                  alt="Video thumbnail" 
                  className="w-full h-full object-cover"
                />
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative">
                        <YoutubeIcon 
                      />
                  </div>
                </div>
  
                {/* Lower Third Info */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <div className="flex items-center gap-3">
                    <div className="bg-red-600 px-3 py-1 rounded text-white text-xs font-bold">
                      ARISE NEWS
                    </div>
                    <div className="text-white">
                      <div className="font-bold text-sm">PASCHAL ANYANWU</div>
                      <div className="text-xs text-gray-300">Exec. Chairman & CVO, Alphaden Holdings</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            {/* Right Column - News List */}
            <div>
              <div className="space-y-8">
                {updates.map((update, index) => (
                  <div 
                    key={index}
                    className="border-b border-gray-200 pb-4 last:border-b-0 last:pb-0 group cursor-pointer"
                  >
                    <div className="text-sm text-[#677078] mb-3">
                      {update.date}
                    </div>
                    <h3 className="text-2xl text-[#010305] group-hover:text-[#E37D33] transition-colors duration-300">
                      {update.title}
                    </h3>
                  </div>
                ))}
              </div>
  
              {/* Read All Link */}
              <a 
                href="/news" 
                className="inline-flex items-center gap-2 text-[#E37D33] hover:text-orange-600 font-semibold mt-8 group"
              >
                Read all here
                <svg
                  className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }